export class MultiCheckboxModel<TKey> {
    key: TKey;
    label: string;
    checked: boolean;

    constructor(key: TKey, value: string, checked: boolean = false) {
        this.key = key;
        this.label = value;
        this.checked = checked;
    }
}